import { Case, Meta } from "typings";

/////////////////////////////////////////////////
// CASES CONSTANTS
/////////////////////////////////////////////////

export const LOAD_CASES = "LOAD_CASES";

/////////////////////////////////////////////////
// CASES ACTIONS
/////////////////////////////////////////////////

export const loadCases = (payload: {
  data: Case[];
  included?: any[];
  meta: Meta;
}) => ({
  type: LOAD_CASES,
  payload,
});

export type CaseAction = {
  type: typeof LOAD_CASES;
  payload: { cases: Case[]; included?: any[]; meta: Meta };
};

/////////////////////////////////////////////////
// CASES REDUCER
/////////////////////////////////////////////////

export interface CaseState {
  isLoading: boolean;
  cases: Case[];
  included?: any[];
  meta: Meta;
}

const initialState: CaseState = {
  isLoading: false,
  cases: [],
  included: [],
  meta: {
    recordCount: 0,
    pageCount: 0,
  },
};

export default (state = initialState, action: CaseAction) => {
  switch (action.type) {
    case LOAD_CASES: {
      return {
        ...state,
        cases: action.payload.cases,
        meta: action.payload.meta,
      };
    }
    default:
      return state;
  }
};
